export default "__VITE_ASSET__78f16512__";